import { Component } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
   selector: 'app-privacy',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './privacy.component.html'
})
export class PrivacyComponent {

}
